module.exports = __webpack_public_path__ + "img/Wp_2059.44414a85.png";